import React, { useCallback, useState, useEffect, useContext, useRef } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, CircularProgress, Collapse, Dialog, DialogContent, Divider, Grid, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Menu, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, TextField, Tooltip, Typography, DialogTitle } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import SuccessIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import * as XLSX from 'xlsx';
import { AssignmentTurnedIn, Cached, Cancel, CancelOutlined, CheckBox, Edit, GroupAdd, RemoveCircle, RemoveCircleOutline, Replay, Timer } from '@material-ui/icons';
import TablePaginationActions from '@material-ui/core/TablePagination/TablePaginationActions';
import GetApp from '@material-ui/icons/GetApp';
import { useHistory, useLocation } from 'react-router-dom';
import {GlobalUseStyles} from "./GlobalUseStyles.js";
import "../config";
import {getBatches, getConsoleMaterials, getBatchOrders, getMaterial, getSharedBy, getSharedWith, shareBatch, unShareBatch, getBatch, DownloadConsoleResults, RefreshStatus, downloadTrace, deleteBatch, DownloadConfigurationXml, GetAllUserMails, downloadFromS3Base64, fetchCompareId, createCompare, executeCompare, checkIfCompareExists, executeBatch, RefreshBatchStatus, deleteBatchParameters, CheckResultExists, CheckConfigTraceExists, PrepareConfigurationXml, PrepareAndCheckResults  } from './RestService';
import { Material } from 'models/Material';

import BatchRow from './BatchRow';
import config from '../config';
import { Autocomplete } from '@material-ui/lab';
import { useSnackbar } from 'react-simple-snackbar';
import { errorSnackbarOptions, successSnackbarOptions, warningSnackbarOptions, infoSnackbarOptions } from './SnackbarOptions';
import cloneDeep from 'lodash/cloneDeep';
import { batch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';      
import { useIsAuthenticated } from "@azure/msal-react";
import { GridWindow } from '@material-ui/data-grid';
import InfiniteScroll from 'react-infinite-scroller';
import { ConvertedTimeString, GetEmpty, GetEmptyValue, LoadParameters } from './Common.js';
import ExecuteDialog from './ExecuteDialog.js';
import { forEach, get } from 'lodash';
import InfoIcon from '@material-ui/icons/Info'; // Add at top if you want an info icon
import ModalPopup from './ModalPopup';

const pdmRelationships = {"has part": "\"cws_configure_has_part\"", "all relationships": "\"cws_configure_all_relationships\"", "no relationships": "\"cws_configure_no_relationships\""};

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function handleValidEmailCheck(emailtxt) {
    if (!emailtxt) return false;

    const emails = String(emailtxt)
        .split(",")
        .map(email => email.trim())
        .filter(email => email);

    return emails.length > 0 &&
           emails.every(email => emailPattern.test(email));
}

const initialTitles = [
    { key: 'Characteristic', name: 'Characteristic', resizable: true, width: "240px", editable: true, frozen: true, defaultTitle: "true" },
    { key: 'Type', name: 'Type', resizable: true, width: "30px", editable: true, frozen: true, defaultTitle: "true" },
    { key: 'Default value', name: 'Default', resizable: true, width: "5px", editable: true, frozen: true, defaultTitle: "true" },
  ];
    
let titles = [
    { key: 'Characteristic', name: 'Characteristic', resizable: true, width: "240px", editable: true, frozen: true, defaultTitle: "true" },
    { key: 'Type', name: 'Type', resizable: true, width: "30px", editable: true, frozen: true, defaultTitle: "true" },
    { key: 'Default value', name: 'Default', resizable: true, width: "5px", editable: true, frozen: true, defaultTitle: "true" },
  ];

function ExcelDateToJSDate(date) {
    return new Date(Math.round((date - 25569) * 86400 * 1000)).toUTCString();
}

function useForceUpdate() {
    const [value, setValue] = useState(0);
    return () => setValue(value => value + 1);
}

var fetchBatches = true;
export var consoleMaterialList = [];
export var consoleMaterials = [];

const useStyles = makeStyles((theme) => ({
    root: {
      },
    
      item: {
        padding: "0 8px"
      },
    mainTable: {
        tableLayout: "fixed",
        padding: "0 14px !important"
    },
    tableContainer: {
        position: "absolute", 
        top: "130px", 
        bottom: 0, 
        left: 0, 
        right: 0, 
        width:"95%",
        margin: "28px",
        overflowY: "scroll"
    },
    overflowHidden: {
        overflowY: "hidden"
    },
    tableBatchesLabel: {
        // fontFamily: 'Mulish',
        // fontStyle: "bold"
    },
    tableOrdersLabel: {
        // fontFamily: 'Mulish',
        // fontStyle: "bold"
    },
    batchTitleRow: {
        flexDirection: "column"
    },
    batchTitleCell: {
        padding: "4px 16px",
    },
    batchDataRow: {
        flexDirection: "column",
        height: "65px",
        minHeight: "12px"
    },
    activeBatch: {
        backgroundColor: "#E0F2FB"
    },
    activeBatchText: {
        fontWeight: "bold"
    },
    batchCell: {
        padding: "0px 0px",
        width: "20%"
    },
    batchPaginationRow: {
        padding: "4px 16px",
        height: "16px",
    },
    orderTable: {
        backgroundColor: "#EEEEEE",
        tableLayout: "fixed",
        width: "100%",
        borderCollapse: "collapse"
    },
    orderRow: {
        height: 20
    },
    orderFirstRowCell: {
        borderBottom: "none",
        paddingTop: "22px",
        paddingBottom: "2px"
    },
    orderCell: {
        borderBottom: "none",
        paddingTop: "2px",
        paddingBottom: "2px",
    },

    dialogPaper: {
        padding: "0px 0px",
        minWidth: "300px",
        maxWidth: "380px"
    },
    customButton: {
        padding: "0"
    },
    newbatchCell: {
        padding: "0px 0px",
        width: "auto"
    },
    tableres: {
        tableLayout: "inherit",
        padding: "0px !important",
        borderCollapse: "collapse"
    }
}));

export default function TableBatches(props) {
    const classes = useStyles();
    const globalClasses = GlobalUseStyles();
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const [batchesExcel, setBatchesExcel] = useState([]);
    const [batches, setBatches] = useState([]);
    const [filteredBatches, setFilteredBatches] = useState([]);
    const [batchesLoaded, setBatchesLoaded] = React.useState(0);
    const [batchesLoading, setBatchesLoading] = React.useState(false);
    const [endReached, setEndReached] = React.useState(false);
    const [batchesLen, setBatchesLen] = useState(-1);
    const [batchData, setBatchData] = useState([]);
    const [newBatchData, setNewBatchData] = useState([]);
    const [allBatchesData, setAllBatchesData] = useState([]);
    const [allSharedData, setAllSharedData] = useState([]);
    //const [handleLoader, setHandleLoader] = useState(sessionStorage.getItem("HandleLoader"));
    const [reRender, setReRender] = useState(false);
    const [currentSelection, setCurrentSelection] = useState([]);
    const [page, setPage] = React.useState(0);
    const [excelDataLen, setExcelDataLen] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [maxBatches, setMaxBatches] = React.useState(25);
    const [showFooter, setShowFooter] = React.useState(false);
    const [showEmpty, setShowEmpty] = React.useState(false);
    const [compareName, setCompareName] = useState("");
    const [anchorElDownload, setAnchorElDownload] = React.useState(null);
    const [clickedOrder, setClickedOrder] = React.useState(null);
    const [anchorElBatch, setAnchorElBatch] = React.useState(null);
    const [editLocked, setEditLocked] = React.useState(false);
    const [currentBatch, setCurrentBatch] = React.useState(null);
    const [selectedBatch, setSelectedBatch] = React.useState(null);
    const [shareObj, setShareObj] = React.useState(null);
    const [shareDialogOpen, setShareDialogOpen] = React.useState(false);
    const [shareInputValue, setShareInputValue] = React.useState("");
    const [shareChanged, setShareChanged] = React.useState(false);
    const [selectedUsers, setSelectedUsers] = React.useState([]);
    const [emptyTable, setEmptyTable] = React.useState(false);
    const [initialSelectedUsers, setInitialSelectedUsers] = React.useState([]);
    const [skipModeValues, setSkipModeValues] = useState([]);
    const [errorModeDialogOpen, setErrorModeDialogOpen] = React.useState(false);
    const [orderErrorModeErrors, setOrderErrorModeErrors] = React.useState([]);
    const [errorModeComponents, setErrorModeComponents] = React.useState([]);

    const [openExecuteDialog, setOpenExecuteDialog] = useState(false);
    const [toggleAll, setToggleAll] = useState(false);
    const [callToggleAll, setCallToggleAll] = useState(false);
    const [orderTitles, setOrderTitles] = useState(titles);
    const [caseSelect, setCaseSelect] = React.useState([]);
    const [selectedBatchOrders, setSelectedBatchOrders] = useState(props.selectedBatchOrders == null ? null : props.selectedBatchOrders);
    const [executeSettings, setExecuteSettings] = useState(new Map());

    const [openSuccessSnackbar, closeSuccessSnackbar] = useSnackbar(successSnackbarOptions());
    const [openErrorSnackbar, closeErrorSnackbar] = useSnackbar(errorSnackbarOptions());
    const [openWarningSnackbar, closeWarningSnackbar] = useSnackbar(warningSnackbarOptions());
    const [openInfoSnackbar, closeInfoSnackbar] = useSnackbar(infoSnackbarOptions());
    const { instance, accounts, inProgress } = useMsal();
    const forceUpdate = useForceUpdate();

    const pathHandler = props.pathHandler;
    const matName = props.materialName;
    const indexHandler = props.indexHandler;
    const setPropsSelectedBatch = props.selectedBatch;
    const selectedOrders = props.selectedOrders;
    const selectedKMID = props.selectedKMID;
    const selectedKMRev = props.selectedKMRev;
    const history = useHistory();
    const location = useLocation();    
    const isAuthenticated = useIsAuthenticated();
    const tempUsers = [];
    //let currentBatch = null;
    let currentBatches = null;
    const [isValidUser, setIsValidUser] = useState(true);
    const [allUserMails, setAllUserMails] = React.useState([]);
    const [circularProgressXMLOpen, setCircularProgressXMLOpen] = useState(false);
    const intervalRef = useRef(null);

    const [id, setID] = useState(2);
    const [xmlLoading, setXmlLoading] = React.useState(false);

    const [modalOpen, setModalOpen] = useState(false);
    const [pdmUsername, setPdmUsername] = useState('');
    const [modalResult, setModalResult] = useState(null);
    const [modalResolve, setModalResolve] = useState(null);
    const modalResolveRef = useRef(null);
    const pendingAction = useRef(null);
    const [downloadAvailability, setDownloadAvailability] = useState({});
    const loadingParamsRef = useRef({});
    const [pdmOrderXmlMissing, setPdmOrderXmlMissing] = useState({});
    const preparingPdmOrderXmlRef = useRef({});
    const [batchDownloadAvailable, setBatchDownloadAvailable] = useState({});
    const checkingBatchDownloadRef = useRef({});
    const loadedAnyParamsRef = useRef(false);
    const paramsRenderTimerRef = useRef(null);

    const openLoginModal = () => {
    console.log('openLoginModal called'); // Debug log
    return new Promise((resolve) => {
        setModalOpen(true);
        modalResolveRef.current = (result) => {
        console.log('Modal resolving with:', result); // Debug log
        setModalOpen(false);
        setModalResult(result);
        resolve(result);
        };
    });
    };

    const checkPDMLogin = async () => {
        let result = null;  
        let pdmLoginFailed = sessionStorage.getItem("pdmLoginFailed");
        if (pdmLoginFailed == "false")
        {
            return true;
        }

        result = await openLoginModal();

        console.log("RESULT: ", result);
        if (result && result.canceled && result.canceled == true)
        {
            openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"PDM Login cancelled"}</p></div>,300000)
            return false;
        }
        if (result && result.success && result.success == false)
        {
            let errorMsg = "Error during PDM login.";
            if (result.error && result.error != "")
            {
                errorMsg = result.error;
            }
            openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{errorMsg}</p></div>,300000)
            return false;
        }
        if (result && result.success == true) {
            return true;
        }
        return false;
        };

        const checkPDMLoginAndRun = async (actionToRun) => {
        let pdmLoginFailed = sessionStorage.getItem("pdmLoginFailed");
            console.log("pdmLoginFailed: ", pdmLoginFailed);
        if (pdmLoginFailed === "false") {
            actionToRun();
            return;
        }

        pendingAction.current = actionToRun;
        setModalOpen(true);
    };

    const handleModalResolve = (result) => {
        setModalOpen(false); // Always close the modal
        console.log("Modal result:", result);
        if (result && result.success) {
        // Login was successful!
        // Check if we have an action waiting to be run.
        if (pendingAction.current) {
            pendingAction.current(); // Run the action (e.g., the download)
        }
        } else if (result && result.canceled) {
        // Handle cancellation
        openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"PDM Login cancelled"}</p></div>,300000);
        } else if (result && result.error) {
        // Handle login error
        openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{result.error}</p></div>,300000);
        }
        
        pendingAction.current = null; // Clear the pending action
    };

    const loading = async () => {
        if (batchesLoading == false)
        {
            setBatchesLoading(true);

            setBatchesLoaded(batchesLoaded+25);
            mapBatches();
            setBatchesLoading(false);
            if (props.materialSearch == "")
            {
                if (batchesLoaded > batchData.length)
                {
                    setEndReached(true);
                }
            }
            else 
            {
                if (batchesLoaded >= filteredBatches.length)
                {
                    setEndReached(true);
                }
            }
        }
    }

    const listAllUserMails = async (val) => {
        
        const mails = await GetAllUserMails(instance);

        const emailOpt = mails.map(item =>item.mail);
        
        setAllUserMails(emailOpt);
        
        // console.log(emailOpt);
    }

    const handleBatchEditClick = async () => {
        await LoadParameters(instance, currentBatch);
        history.push("/batch");
        indexHandler(1);
    };

    const handleInputSelected = () => {
        let checkValidTxt = "True";
        var spans = document.querySelectorAll('.MuiChip-label');
        
        if(spans.length > 0) {
            spans.forEach(function(span){
                var spanText = span.textContent;
                // spanText = spanText.toLowerCase()
                console.log(spanText);
                if(spanText && !handleValidEmailCheck(spanText)) {
                    checkValidTxt = "False";
                } else if (spanText && handleValidEmailCheck(spanText)) {
                    selectedUsers.includes(spanText) ? spanText : setSelectedUsers([...selectedUsers, spanText]);
                }
            });

            if(checkValidTxt != "True") {
                setIsValidUser(false);
                setShareChanged(true);
            } else {
                setIsValidUser(true);
                setShareChanged(true);
            }
        }
    }

    const handleBatchCopyClick = async () => {
        await LoadParameters(instance, currentBatch);
        let tempBatch = cloneDeep(currentBatch);
        const trimmedName = tempBatch["orders"].map(order => order.name.slice(-8));
        if (!tempBatch["executeOrders"]) {
                tempBatch["executeOrders"] = trimmedName;
        }
        tempBatch["id"] = "";
        tempBatch["name"] = "";
        tempBatch["status"] = "Not run";
        let tmpOrders = [];
        if (!GetEmpty(tempBatch["orders"]))
        {
            tempBatch["orders"].forEach(element => {
                tmpOrders.push({
                    "batchID": "",
                    "name": element["name"],
                    "description": "",
                    "status": "Not run",
                    "message": null,
                    "resultFiles": [],
                    "characteristics": element["characteristics"]
                })
            });
        }
        props.setCopyBatch(true);
        props.setNewBatch(true);
        setPropsSelectedBatch(tempBatch);
        if (!GetEmpty(tempBatch["orders"]))
        {
            props.selectedOrders(tempBatch["orders"]);
        }
        history.push("/batch");
        indexHandler(1);
    };

    const handleSetSelectedShareUsers = (e, value) => {
        if(!value.length) {
            setIsValidUser(true);
            return;
        } 
        
        let handleValidResult = handleValidEmailCheck(value)
        
        if (value && !handleValidResult) {
            setIsValidUser(false);
            return;
        } 
        
        setSelectedUsers([...value]);
        setIsValidUser(true);
        
        let tempAllSharedAndSelected = value;
        
        if (shareObj != null)
        {
            if (shareObj["batch"] != undefined)
            {
                tempAllSharedAndSelected = tempAllSharedAndSelected.concat(shareObj["batch"]["sharedTo"]);
            }
        }
        let tmpShareChanged = false;
        if (initialSelectedUsers.length != tempAllSharedAndSelected.length)
        {
            tmpShareChanged = true;
        }
        // Number of users has not changed, check if the arrays contain different strings
        else if (initialSelectedUsers.length == tempAllSharedAndSelected.length)
        {
            if (!initialSelectedUsers.every(function (item){return tempAllSharedAndSelected.indexOf(item) > -1}))
            {
                tmpShareChanged = true;
            }
        }
        setShareChanged(tmpShareChanged);
    };

    const handleBatchDeleteClick = () => {
        if (confirm("Are you sure you want to delete batch " + currentBatch["name"] + "?"))
        {
            var delResult = null;
            var delParametersResult = null;
            var message = "";
            setAnchorElBatch(null);
            const data = async () => {
                delResult = await deleteBatch(instance, currentBatch["id"], accounts[0].username);
                delParametersResult = await deleteBatchParameters(instance, currentBatch["id"]);
            }
            data().catch((error)=>{
                console.error(error);
                message = "Error: " + error.message;
            }).then(() => {
                if (message != "")
                {
                    openErrorSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{message}</p></div>,300000);
                } 
                else 
                {
                    let tmpBatchData = [...props.batches];
                    var newBatchData = tmpBatchData.filter((obj) => {
                        return obj["id"] !== currentBatch["id"];
                    });
                    props.setBatches(newBatchData);
                    openSuccessSnackbar(<div style={{whiteSpace: "nowrap"}}><SuccessIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Batch deleted successfully."}</p></div>,300000);
                    if (newBatchData.length == 0)
                    {
                        setBatches([]);
                        setEmptyTable(true);
                    }
                }
            });
        }
    };

    const handleBatchShareOpenClick = (e, newShareObj, _batch = null) => {

        listAllUserMails();
        
        setShareChanged(false);
        
        if (anchorElBatch)
        {
            if (currentBatch != null && currentBatch["sharedTo"] != null)
            {
                setInitialSelectedUsers(currentBatch["sharedTo"]);
            }
        }
        else
        {
            if (_batch != null && _batch["sharedTo"] != null)
            {
                setInitialSelectedUsers(_batch["sharedTo"]);
            }
        }
        setSelectedUsers([]);
        if (_batch != null){
            setCurrentBatch(_batch);
        }

        if (newShareObj != null) {
            setShareObj(newShareObj);
        }
        setShareDialogOpen(true);
        setAnchorElBatch(null);
    };

    const handleShareDialogClose = () => {
        let tempAllSharedAndSelected = selectedUsers;
        if (!selectedUsers.length) {
            setIsValidUser(true);
        }
        if (shareObj != null)
        {
            if (shareObj["batch"] != undefined)
            {
                tempAllSharedAndSelected = tempAllSharedAndSelected.concat(shareObj["batch"]["sharedTo"]);
            }
        }
        let changed = false;
        if (initialSelectedUsers.length != tempAllSharedAndSelected.length)
        {
            changed = true;
        }
        // Number of users has not changed, check if the arrays contain different strings
        else if (initialSelectedUsers.length == tempAllSharedAndSelected.length)
        {
            if (!initialSelectedUsers.every(function (item){return tempAllSharedAndSelected.indexOf(item) > -1}))
            {
                changed = true;
            }
        }
        if (changed == true)
        {
            if (confirm("The list of shared people has changed and need to be saved by clicking Share-button or they won't be saved. Are you sure you want to exit?"))
            {
                setIsValidUser(true);
                setShareDialogOpen(false);
            }
        }
        else
        {
        setShareDialogOpen(false);
        }
    };

    const handleBatchShareClick = () => {
        let tempUsers = selectedUsers;
        console.log("USERS: ", tempUsers);
        if (shareObj != null)
        {
            if (shareObj["batch"] != undefined)
            {
                tempUsers = tempUsers.concat(shareObj["batch"]["sharedTo"]);
            }
        }
        let message = "";
        let shareData = null;

        const data = async () => {
            if (tempUsers.length == 0)
            {
                shareData = await unShareBatch(instance, currentBatch["id"]);
            }
            else
            {
                tempUsers.forEach(element => {
                    let domain = element.substring(element.lastIndexOf("@"));
                    console.log("DOMAIN: ", domain);
                    if (domain && !domain.toLowerCase().endsWith("kone.com"))
                    {
                        if (message == "")
                        {
                            message = "Invalid domains: ";
                        }
                        message += element + " ";
                    }
                });
                if (message == "")
                {
                    shareData = await shareBatch(instance, currentBatch["id"], tempUsers);
                } else {
                    return false;
                }
            }
        };
        data().catch((error)=>{
            console.error(error);
            message = "Error: " + error.message;
        }).then(() => {
            if (message != "")
            {
                openErrorSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{message}</p></div>,300000);
            } 
            else 
            {
                openSuccessSnackbar(<div style={{whiteSpace: "nowrap"}}><SuccessIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Batch sharing list succesfully updated."}</p></div>,300000);
                if (typeof props.setNewBatch === 'function')
                {
                    props.setNewBatch(false);
                }
                currentBatch["sharedTo"] = tempUsers;

                const newName = currentBatch["name"];
                const newObj = {};
                let tempArr = allSharedData.filter((obj) => {                    
                    return newName != Object.keys(obj)[0];
                });
                newObj[newName] = tempUsers;
                tempArr.push(newObj);
                setAllSharedData([...tempArr]);
                // window.location.reload();
            }
            
            setShareDialogOpen(false);
            
        });
    }

    const handleBatchRemoveShareClick = (e, _currentBatch) => {

        let message = "";
        let shareData = null;
        let tempShareObj = cloneDeep(shareObj);
        console.log("e: ", e);
        console.log("shareObj: ", shareObj);
        //shareObj["batch"]["sharedTo"]
        let index = tempShareObj["batch"]["sharedTo"].indexOf(e);
        if (index !== -1)
        {
            tempShareObj["batch"]["sharedTo"].splice(index, 1);
            setShareObj(tempShareObj);
        }

        let tempAllSharedAndSelected = selectedUsers;
        if (tempShareObj != null)
        {
            if (tempShareObj["batch"] != undefined)
            {
                tempAllSharedAndSelected = tempAllSharedAndSelected.concat(tempShareObj["batch"]["sharedTo"]);
            }
        }
        let tmpShareChanged = false;
        if (initialSelectedUsers.length != tempAllSharedAndSelected.length)
        {
            tmpShareChanged = true;
        }
        // Number of users has not changed, check if the arrays contain different strings
        else if (initialSelectedUsers.length == tempAllSharedAndSelected.length)
        {
            if (!initialSelectedUsers.every(function (item){return tempAllSharedAndSelected.indexOf(item) > -1}))
            {
                tmpShareChanged = true;
            }
        }
        setShareChanged(tmpShareChanged);
    }

    const handleCloseErrorMode = () => {
        setErrorModeDialogOpen(false);
    };

    const handleSetErrorModeDialog = (errorArray) => {
        let tmpComponents = [];
        for (var i = 0; i < errorArray.length; i++)
        {
            tmpComponents.push(
                <ListItem key={"errorModeError" + i.toString()} style={{padding: "0", marginTop: "2px", wordWrap: "break-word"}}>
                <ListItemText
                    
                    primaryTypographyProps={{ style: { whiteSpace: "normal" } }}
                    primary={<Typography variant="body1">{errorArray[i]}</Typography>}
                    style={{ paddingLeft: "4px", color: "#666", font: "inherit"}}
                    className={clsx(globalClasses.addBorder)}
                    />
                </ListItem>
                    );
        }
        setErrorModeComponents([...tmpComponents]);
        setOrderErrorModeErrors(errorArray);
        setErrorModeDialogOpen(true);
    }

    const handleBatchExecuteOpenClick = async (e, _batch = null) => {
        console.log("EXECUTE BATCH: ", _batch);
        let tmpExecuteSettings = new Map();
        if (GetEmpty(_batch) == false)        
        {
            await LoadParameters(instance, _batch);
            if (GetEmpty(_batch["executeArguments"]) == false)
            {
                for (const [key, value] of Object.entries(_batch["executeArguments"])) {        
                    if (key == "levelOfScan")
                    {
                    if (value == "deep_check")
                        tmpExecuteSettings.set("deepScan", true);
                    }
                    else
                    {
                        if (typeof value === 'string' || value instanceof String)
                        {
                            tmpExecuteSettings.set(key, (value === 'true'));
                        }
                        else
                        {
                            tmpExecuteSettings.set(key, (value === true));
                        }
                    }
                }
                tmpExecuteSettings.delete("environment");                
                tmpExecuteSettings.delete("relationships");   
                console.log("tmpExecuteSettings edit values:", tmpExecuteSettings);  
            
            }        
            
            console.log("selectedBatch: ", _batch);
            
            if (GetEmpty(_batch["executeOrders"]) == false)
            {
                if (GetEmpty(_batch["orders"]) == false)
                {   
                    let initialOrders = [];
                    let allOrders = [];
                    let regex = new RegExp("(?:" + _batch["executeOrders"].join("|") + ")$");
                    _batch["orders"].map((obj) => {  
                        let setSelected = false;   
                        if(obj["name"].match(regex))
                        {
                            let splitObjNameArr = obj["name"].split("_");
                            let splitObjName = "";
                            if (splitObjNameArr.length > 1)
                            {
                                splitObjName = splitObjNameArr[splitObjNameArr.length-1];
                                splitObjName = splitObjName.replace(/^0+/, '');
                            }
                            else
                            {
                                let splitObjNameArr2 = obj["name"].split("-");
                                if (splitObjNameArr2.length >= 2)
                                {
                                    splitObjName = splitObjNameArr2[splitObjNameArr2.length-2].slice(-4) + "-" + splitObjNameArr2[splitObjNameArr2.length-1];
                                    splitObjName = splitObjName.replace(/^0+/, '');
                                }
                                else
                                {
                                    splitObjName = obj["name"].slice(-4);
                            splitObjName = splitObjName.replace(/^0+/, '');
                                }
                            }
                            setSelected = true;
                            initialOrders.push({ key: obj["name"], name: splitObjName, resizable: true, width: "5%", editable: true, description: obj["description"], selected: true })
                        }
                        let splitObjNameArr = obj["name"].split("_");
                        let splitObjName = "";
                        if (splitObjNameArr.length > 1)
                        {
                            splitObjName = splitObjNameArr[splitObjNameArr.length-1];
                        splitObjName = splitObjName.replace(/^0+/, '');
                        }
                        else
                        {
                            let splitObjNameArr2 = obj["name"].split("-");
                            if (splitObjNameArr2.length >= 2)
                            {
                                splitObjName = splitObjNameArr2[splitObjNameArr2.length-2].slice(-4) + "-" + splitObjNameArr2[splitObjNameArr2.length-1];
                                splitObjName = splitObjName.replace(/^0+/, '');
                            }
                            else
                            {
                                splitObjName = obj["name"].slice(-4);
                                splitObjName = splitObjName.replace(/^0+/, '');
                            }
                        }
                        allOrders.push({ key: obj["name"], name: splitObjName, resizable: true, width: "5%", editable: true, description: obj["description"], selected: setSelected })
                    })
                    console.log("initialOrders:", initialOrders); 
                    if (!initialOrders.some(obj => obj["key"] === "All"))
                    {
                        let newObj = { key: 'All', name: 'All', resizable: true, width: "240px", editable: true, frozen: true, defaultTitle: "false", description: "" }
                        if (initialOrders.length == _batch["orders"].length)
                        {
                            initialOrders.push(newObj);
                            allOrders.push(newObj);
                        }
                    }
                    setCaseSelect([...initialOrders]);

                    let tmpOrderTitles = [...titles];
                    allOrders.forEach(element => {
                        if (!tmpOrderTitles.some((obj) => obj["name"] == element["key"]) )
                        {
                            tmpOrderTitles.push(element);
                        }
                    });
                    setOrderTitles(tmpOrderTitles);
                    console.log("tmpOrderTitles: ", tmpOrderTitles);
                    console.log("selectedBatch2: ", _batch);
                    console.log("initialOrders: ", initialOrders);
                    
                } 
            }
        }
        
        setExecuteSettings(tmpExecuteSettings);
        setSelectedBatch(_batch);
        console.log("openExecuteDialog: ", openExecuteDialog);
        setOpenExecuteDialog(!openExecuteDialog);
        setReRender(!reRender);
    };

    const handleDownloadClose = (e) => {
        setAnchorElDownload(null);
        console.log("close");
    };
    const handleOrderXML = (e) => {
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);
        // DownloadConsoleResults(instance, clickedOrder["configurationId"], accounts[0].username)
        DownloadConsoleResults(instance, clickedOrder["name"], clickedOrder["configurationId"], "XML", accounts[0].username);
        setAnchorElDownload(null); 
    };

    const getExpectedBatchDownloadTypes = (batch) => {
        const args = batch?.executeArguments || {};

        const confPDM = args.confPDM === true || args.confPDM === "true";
        const sendToCAD = args.sendToCAD === true || args.sendToCAD === "true";
        const deepCheck = args.levelOfScan === "deep_check";
        const saveTrace = args.saveTrace === true || args.saveTrace === "true";
        const downloadMFG = args.downloadMFG === true || args.downloadMFG === "true";

        let resultTypes = [];

        if (confPDM) {
            resultTypes.push("PDMORDERXML");
        }

        if (!confPDM && sendToCAD) {
            resultTypes.push("XML");
        }

        if (confPDM && sendToCAD) {
            resultTypes.push("XML");
            resultTypes.push("LOG");
            resultTypes.push("PDM");
        }

        if (confPDM && sendToCAD && deepCheck) {
            resultTypes.push("MCLOG");
        }

        if (confPDM && sendToCAD && downloadMFG) {
            resultTypes.push("MFG");
        }

        if (confPDM && deepCheck && saveTrace) {
            resultTypes.push("TRACE");
        }

        return resultTypes;
    };

    const checkBatchHasAnyDownload = async (batch) => {
    if (!batch || !batch.id)
        return;

    if (checkingBatchDownloadRef.current[batch.id])
        return;

    if (batchDownloadAvailable[batch.id] !== undefined)
        return;

    checkingBatchDownloadRef.current[batch.id] = true;

    try {
        const args = batch.executeArguments || {};

        const confPDM = args.confPDM === true || args.confPDM === "true";
        const sendToCAD = args.sendToCAD === true || args.sendToCAD === "true";
        const deepCheck = args.levelOfScan === "deep_check";
        const saveTrace = args.saveTrace === true || args.saveTrace === "true";
        const downloadMFG = args.downloadMFG === true || args.downloadMFG === "true";

        let resultTypes = [];

        if (confPDM) {
            resultTypes.push("PDMORDERXML");
        }

        if (confPDM && sendToCAD) {
            resultTypes.push("XML");
            resultTypes.push("LOG");
            resultTypes.push("PDM");
        }

        if (confPDM && sendToCAD && deepCheck) {
            resultTypes.push("MCLOG");
        }

        if (confPDM && sendToCAD && downloadMFG) {
            resultTypes.push("MFG");
        }

        if (confPDM && deepCheck && saveTrace) {
            resultTypes.push("TRACE");
        }

        resultTypes = [...new Set(resultTypes)];

        const validOrders = (batch.orders || []).filter(order =>
            order.status !== "Processing" &&
            order.configurationId &&
            order.configurationId !== "not available"
        );

        if (validOrders.length === 0 || resultTypes.length === 0) {
            setBatchDownloadAvailable(prev => ({
                ...prev,
                [batch.id]: prev[batch.id] === true ? true : false
            }));
            return;
        }

        const request = {
            username: accounts[0].username,
            checks: validOrders.flatMap(order =>
                resultTypes.map(resultType => ({
                    configurationId: order.configurationId,
                    orderName: order.name,
                    resultType: resultType,
                    prepareIfMissing: resultType === "PDMORDERXML"
                }))
            )
        };

        const response = await PrepareAndCheckResults(instance, request);

        setDownloadAvailability(prev => ({
            ...prev,
            ...response
        }));

        const hasAnyResult = Object.values(response).some(v => v === true);

        setBatchDownloadAvailable(prev => ({
            ...prev,
            [batch.id]: prev[batch.id] === true ? true : hasAnyResult
        }));
    }
    catch (error) {
        console.log("Batch availability preparation failed:", batch.id, error);

        setBatchDownloadAvailable(prev => ({
            ...prev,
            [batch.id]: prev[batch.id] === true ? true : false
        }));
    }
    finally {
        checkingBatchDownloadRef.current[batch.id] = false;
    }
};

    const isValidConfigurationId = (configurationId) => {
        return (
            configurationId &&
            configurationId !== "" &&
            configurationId !== "not available"
        );
    };

    const isSelectedOrderDownloadAllowed = () => {
        return (
            clickedOrder &&
            isValidConfigurationId(clickedOrder.configurationId)
        );
    };

    const handleCADBOMXML = async (e) => {
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);

        await DownloadConfigurationXml(instance, clickedOrder["configurationId"], accounts[0].username);

        await checkAvailability(clickedOrder, "PDMORDERXML");

        setAnchorElDownload(null);
    };

    const preparePdmOrderXmlIfNeeded = async (order) => {
        if (!order || !order.configurationId || order.configurationId === "not available")
            return;

        const configurationId = order.configurationId;

        if (preparingPdmOrderXmlRef.current[configurationId])
            return;

        preparingPdmOrderXmlRef.current[configurationId] = true;

        try {
            console.log("Auto preparing PDMORDERXML for:", configurationId);

            const prepared = await PrepareConfigurationXml(
                instance,
                configurationId,
                accounts[0].username
            );

            console.log("Auto prepare result:", configurationId, prepared);

            setDownloadAvailability(prev => ({
                ...prev,
                [`${configurationId}_PDMORDERXML`]: prepared
            }));

            setPdmOrderXmlMissing(prev => ({
                ...prev,
                [configurationId]: !prepared
            }));
        }
        catch (error) {
            console.log("Auto prepare PDMORDERXML failed:", configurationId, error);

            setDownloadAvailability(prev => ({
                ...prev,
                [`${configurationId}_PDMORDERXML`]: false
            }));

            setPdmOrderXmlMissing(prev => ({
                ...prev,
                [configurationId]: true
            }));
        }
    };
    
    const checkAvailability = async (order, resultType) => {

        console.log(
            "Checking download availability for",
            order["configurationId"],
            resultType
        );

        try {

            let exists = false;

            if (resultType === "TRACE") {
                exists = await CheckConfigTraceExists(
                    instance,
                    order["name"],
                    accounts[0].username
                );
            }
            else {
                exists = await CheckResultExists(
                    instance,
                    order["configurationId"],
                    resultType,
                    accounts[0].username
                );
            }

            console.log(
                "Availability result",
                order["configurationId"],
                resultType,
                exists
            );

            setDownloadAvailability(prev => ({
                ...prev,
                [`${order["configurationId"]}_${resultType}`]: exists
            }));
            if (resultType === "PDMORDERXML") {
                setPdmOrderXmlMissing(prev => ({
                    ...prev,
                    [order["configurationId"]]: !exists
            }));
}

        }
        catch (error) {

            console.log(
                "Availability check failed",
                order["configurationId"],
                resultType,
                error
            );

            setDownloadAvailability(prev => ({
                ...prev,
                [`${order["configurationId"]}_${resultType}`]: false
            }));

            if (resultType === "PDMORDERXML") {
                setPdmOrderXmlMissing(prev => ({
                    ...prev,
                    [order["configurationId"]]: true
                }));
            }
        }
    };

    const checkAllDownloadAvailability = async (order, batch) => {

        const args = batch?.executeArguments || {};

        const confPDM = args.confPDM === "true";
        const sendToCAD = args.sendToCAD === "true";
        const deepCheck = args.levelOfScan === "deep_check";
        const saveTrace = args.saveTrace === "true";
        const downloadMFG = args.downloadMFG === "true";

        let resultTypes = [];

        if (confPDM) {
            resultTypes.push("PDMORDERXML");
        }

        if (sendToCAD) {
            resultTypes.push("XML");
        }

        if (confPDM && sendToCAD) {
            resultTypes.push("XML");
            resultTypes.push("LOG");
            resultTypes.push("PDM");
        }

        if (confPDM && sendToCAD && deepCheck) {
            resultTypes.push("MCLOG");
        }

        if (confPDM && sendToCAD && downloadMFG) {
            resultTypes.push("MFG");
        }

        if (confPDM && deepCheck && saveTrace) {
            resultTypes.push("TRACE");
        }

        console.log("Filtered resultTypes:", resultTypes);

        for (const resultType of resultTypes) {
            await checkAvailability(order, resultType);
        }
    };

    useEffect(() => {

        const loadAvailability = async () => {

            if (!clickedOrder || !clickedOrder["configurationId"])
                return;

            await checkAllDownloadAvailability(clickedOrder, selectedBatch);
        };

        loadAvailability();

    }, [clickedOrder]);

    const handleOrderMFGDownload = (e) => {
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);
        DownloadConsoleResults(instance, clickedOrder["name"], clickedOrder["configurationId"], "MFG", accounts[0].username)
        setAnchorElDownload(null); 
    }; 


    const getStoredCompareName = (configurationId) => {
        const key = `compareName_${configurationId}`;
        return localStorage.getItem(key);
    };
    
    const setStoredCompareName = (configurationId, compareName) => {
        const key = `compareName_${configurationId}`;
        localStorage.setItem(key, compareName);
    };



    const [pdmCompareAvailable, setPdmCompareAvailable] = useState(true);
    const [pdmCompareLoading, setPdmCompareLoading] = useState(false);
    const [pdmCompareTooltip, setPdmCompareTooltip] = useState("Download PDM CAD Comparison");

    useEffect(() => {
        // Check if file exists when menu opens or clickedOrder changes
        const checkCompare = async () => {
            if (clickedOrder && clickedOrder["configurationId"]) {
                setPdmCompareLoading(true);
                const configurationId = clickedOrder["configurationId"];
                let name = compareName || getStoredCompareName(configurationId);
                if (name) {
                    const exists = await checkIfCompareExists(instance, "Compare", name);
                    setPdmCompareAvailable(exists);
                    setPdmCompareTooltip(exists ? "Download PDM CAD Comparison" : "Batch needs to be run for PDM CAD Comparison");
                } else {
                    setPdmCompareAvailable(false);
                    setPdmCompareTooltip("Batch needs to be run for PDM CAD Comparison");
                }
                setPdmCompareLoading(false);
            }
        };
        checkCompare();
    }, [clickedOrder, compareName]);

    const handlePDMCADComp = async () => {
        const configurationId = clickedOrder["configurationId"];
        let name = compareName || getStoredCompareName(configurationId);

        if (pdmCompareAvailable && name) {
            downloadFromS3Base64(instance, "Compare", name);
            setAnchorElDownload(null);
        } else {
            if (window.confirm("PDM CAD Comparison file does not exist. Would you like to rerun the batch?")) {
                openInfoSnackbar("Batch is being rerun. PDM CAD Comparison will be available once complete.", 150000);
                    const batchResult = await executeBatch(
                        instance,
                        selectedBatch["id"], // or selectedBatchID
                        selectedBatch["executeOrders"], // or tableOrders
                        selectedBatch["executeArguments"],
                        selectedBatch["orders"], // or tableOrders
                        selectedBatch["ad_name"] // or ad_name
                    );                    
                    window.location.reload();
            }
            setAnchorElDownload(null);
        }
    };


    const handleCADLog = (e) => { 
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);
        DownloadConsoleResults(instance, clickedOrder["name"], clickedOrder["configurationId"], "LOG", accounts[0].username)
      setAnchorElDownload(null); 
    }; 
    const handleCADResult = (e) => { 
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);
        DownloadConsoleResults(instance, clickedOrder["name"], clickedOrder["configurationId"], "PDM", accounts[0].username)
      setAnchorElDownload(null); 
    }; 
    const handleCADCheck = (e) => { 
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);
        DownloadConsoleResults(instance, clickedOrder["name"], clickedOrder["configurationId"], "MCLOG", accounts[0].username)
      setAnchorElDownload(null); 
    };
    const handleTrace = (e) => { 
        sessionStorage.setItem("circularProgressXML", "true");
        setXmlLoading(true);
        setCircularProgressXMLOpen(true);
        downloadTrace(instance, clickedOrder["name"], accounts[0].username)
       setAnchorElDownload(null); 
     };

     useEffect(() => {
        console.log("checking for downloading");
        if(xmlLoading)
        {
            intervalRef.current = setInterval(() => {
                let circularProgressXML = sessionStorage.getItem("circularProgressXML");
                if(circularProgressXML=="false")
                {
                    setCircularProgressXMLOpen(false);
                    if(document.getElementById("CirProgXML"))
                    {
                        document.getElementById("CirProgXML").style.display="none";
                    }
                    sessionStorage.removeItem("circularProgressXML");
                    setXmlLoading(false);
                    clearInterval(intervalRef.current);
                    intervalRef.current = null;
                }
                console.log("waiting for downloading completion");
            }, 1000);
            return () => {
                if (intervalRef.current) {
                clearInterval(intervalRef.current);
                }
            };
        }
    }, [circularProgressXMLOpen]);
    

    const handleBatchClose = () => {
        setAnchorElBatch(null);
    };

    const handleSetAnchorElBatch = (e, b, kmID, kmRev, clickedOrders, newShareObj) => {
        setAnchorElBatch(e.currentTarget);
        setPropsSelectedBatch(b);
        setCurrentBatch(b);
        selectedKMID(b["material"]);
        selectedKMRev(b["materialRevision"]);
        selectedOrders(clickedOrders);
        setShareObj(newShareObj);
        setEditLocked(b["status"] == "Processing" || b["createdBy"] != accounts[0].username ? true : false);
    };

    const handleBatchClick = (index, clickedBatch) => {
        var indexOfValue = Array.from(currentSelection).indexOf(index);
        if (indexOfValue > -1) {
            setCurrentSelection(currentSelection => currentSelection.filter(item => item !== index));
        }
        else {
            currentSelection.push(index);
            setCurrentSelection([...currentSelection]);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setReRender(!reRender);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setReRender(!reRender);
    };

    const handleEditClick = (e, clickedBatch, kmID, kmRev, clickedOrders) => {
        setPropsSelectedBatch(clickedBatch);
        selectedKMID(kmID);
        selectedKMRev(kmRev);
        selectedOrders(clickedOrders);
        history.push("/batch");
        indexHandler(1);
    };

    const handleCancelClick = async (clickedBatch) => {
        await LoadParameters(instance, clickedBatch);
        let tmpBatchData = batchData;
        var batch = tmpBatchData.findIndex((obj) => {
            return obj["id"] == clickedBatch["id"];
        });
        tmpBatchData[batch]["status"] = clickedBatch["status"];
        tmpBatchData[batch]["orders"].forEach(order => {
            if (order["status"] == "Processing")
            {
                order["status"] = "Not run";
            }
        });
        props.setBatches(tmpBatchData);
    };


    const fetchData = async () => { 
        if (fetchBatches == true) {
            fetchBatches = false;
            
            console.log("Retrieving batch data for " + accounts[0].username);
            
            const batches = await getBatches(instance);
            if (batches["exception"])
            {
                openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{batches["exception"]}</p></div>,300000)
            }
            else
            {
                setBatchData([...batches]);
                props.setBatches([...batches]);
            }
            }
    }

    const mapBatches = () => {
        if (batchesLoading == true) {return;}
        if (batchData == null) {return;}
        if (batchData.length == 0) { return; } 
        let newBatches = [];
        let lastID = "CWS0000000000"
        let allBatches = [];

        emptyRows = rowsPerPage - Math.min(rowsPerPage, batchData.length - page * rowsPerPage);
        setBatchesLen(batchData.length);
        let tmpBatchData = [...batchData];
        tmpBatchData = tmpBatchData.filter((i) => i.batch !== null);
        tmpBatchData.sort((a, b) => new Date(a["created"]).valueOf() - new Date(b["created"]).valueOf());
        tmpBatchData.sort((a, b) => +(a["status"] == "Not run" && a["status"] != b["status"]));
        if (props.statusFilter)
        {
            if (!props.statusFilter.includes("All"))
            {
                tmpBatchData = tmpBatchData.filter((b) => props.statusFilter.includes(b["status"]));
            }
        }
            
        let slicedArray = tmpBatchData.slice();
        
        slicedArray.map((b, index3) => {
            if (props.showShared == true)
            {
                b = b["batch"];
            }
            if(b) {
            let IDStr = b["name"].replace(/\D/g, '');
            let num = parseInt(IDStr, 10);
            let IDStr2 = lastID.replace(/\D/g, '');
            let num2 = parseInt(IDStr2, 10);

            if (num > num2) {
                props.setLastID(b["name"]);
                lastID = b["name"];
            }

            let statusIcon = null;
            if (b["status"] === "Success") {
                statusIcon = <SuccessIcon className={globalClasses.successIcon} />
            }
            else if (b["status"]?.toLowerCase() === "failed" ||
                        b["status"]?.toLowerCase() === "pdm import error") {
                statusIcon = <ErrorIcon className={globalClasses.errorIcon} />
            }
            else if (b["status"] === "InProgress" || b["status"] === "Processing") {
                statusIcon = <Cached className={globalClasses.inProgressIcon} />
            }
            else if (b["status"] === "Not run") {
                statusIcon = <RemoveCircleOutline className={globalClasses.NotRunIcon} />
            }
            else if (b["status"] === "Cancelled") {
                statusIcon = <Cancel className={globalClasses.cancelledIcon} />
            }
            else if (b["status"] === "PartialFailed") {
                statusIcon = <ErrorIcon style={{ color: '#F2AF17', fontSize: 25 }} />
            }
            let date = new Date(b["lastRun"]);

            const orderSecondaryText = <>{b["createdBy"]}
                &nbsp;&nbsp;{ConvertedTimeString(b["created"])}</>

            let orders = [];
            allBatches.push({ "created": b["created"], "key": b["id"] + "_" + index3, "currentSelection": currentSelection, "classes": classes, "globalClasses": globalClasses, "lastRun": b["lastRun"], "index": index3, "batch": b, "material": b["material"], "statusIcon": statusIcon, "orderSecondaryText": orderSecondaryText, "handleBatchClick": handleBatchClick, "handleEditClick": handleEditClick });
            }
        });
        let notRunBatches = allBatches.filter((e) => e["batch"]["status"] == "Not run");
        let runBatches = allBatches.filter((e) => e["batch"]["status"] != "Not run");

        notRunBatches.sort((a, b) => new Date(a["batch"]["created"]).valueOf() - new Date(b["batch"]["created"]).valueOf()).reverse();
        runBatches.sort((a, b) => new Date(a["batch"]["lastRun"]).valueOf() - new Date(b["batch"]["lastRun"]).valueOf()).reverse();

        let newAllBatches = [];
        let newAllBatchData = [];
        let tmpFilteredBatches = [];
        newAllBatches = newAllBatches.concat(runBatches);
        newAllBatches = newAllBatches.concat(notRunBatches);
        
        if (props.showShared == true)
        {
            let newData = null;
            let sharedBatches = [];
            let newAllBatchesArr = [];
            newAllBatchesArr = allBatches;
            //allBatches.sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf()).reverse();
            if (newAllBatchesArr.length > 0) {
                setAllBatchesData(newAllBatches);
                newAllBatchesArr.forEach(element => {
                    let batchEl = element["batch"];
                    let newShareObj = null;
                    let hasBeenShared = false;
                    newAllBatchData.push(batchEl);
                    newBatches.push(
                        <BatchRow batchesErrorModes={props.batchesErrorModes} handleSetErrorModeDialog={handleSetErrorModeDialog} sharedToMe={true} handleBatchExecuteOpenClick={handleBatchExecuteOpenClick} setSelectedBatch={setSelectedBatch} handleCancelClick={handleCancelClick} reRender={reRender} setReRender={setReRender} setClickedOrder={setClickedOrder} shareObj={newShareObj} handleBatchShareOpenClick={handleBatchShareOpenClick} hasBeenShared={hasBeenShared} handleSetAnchorElBatch={handleSetAnchorElBatch} setAnchorElDownload={setAnchorElDownload} key={element["key"]} currentSelection={element["currentSelection"]} classes={element["classes"]} globalClasses={element["globalClasses"]} lastRun={element["lastRun"]} index={element["index"]} batch={element["batch"]} material={element["material"]} statusIcon={element["statusIcon"]} orderSecondaryText={element["orderSecondaryText"]} handleBatchClick={element["handleBatchClick"]} handleEditClick={element["handleEditClick"]} checkPDMLoginAndRun={checkPDMLoginAndRun} downloadAvailability={downloadAvailability} pdmOrderXmlMissing={pdmOrderXmlMissing} batchDownloadAvailable={batchDownloadAvailable}></BatchRow>
                    );
                });
            }
            currentBatches = newBatches;
            if (newBatches.length == 0)
            {
                setShowEmpty(true);
            } 
            else 
            {
                setShowEmpty(false);
            }
                setNewBatchData(newAllBatchData);
                setBatches(newBatches);
                   
        }
        else {
            allBatches.sort((a, b) => new Date(a["lastRun"]).valueOf() - new Date(b["lastRun"]).valueOf()).reverse();
            if (newAllBatches.length > 0) {
                
                setAllBatchesData(newAllBatches);
                tmpFilteredBatches = tmpFilteredBatches.concat(newAllBatches);
                if (props.materialSearch)
                {
                    tmpFilteredBatches = tmpFilteredBatches.filter((element) => element["batch"]["material"].toString().toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1 
                    || element["batch"]["materialRevision"].toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1 
                    || (element["batch"]["material"] + "/" + element["batch"]["materialRevision"]).toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1
                    || (element["batch"]["material"] + "/").toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1
                    || element["batch"]["name"].toString().toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1)
                }

                if (props.homePage == true) {
                    newAllBatches = newAllBatches.slice(0, 5);
                }
                else {
                    newAllBatches = newAllBatches.slice(0, batchesLoaded);
                }
                newAllBatches.forEach(element => {
                    const batch = element["batch"];
                    const status = batch?.status?.toLowerCase();

                    if (
                        (status === "success" || status === "partialfailed" || status === "failed" || status === "not run") &&
                        (Array.isArray(batch.orders) && batch.orders.length > 0) && 
                        batchDownloadAvailable[batch.id] === undefined &&
                        !checkingBatchDownloadRef.current[batch.id])
                    {
                            checkBatchHasAnyDownload(batch);
                    }                    

                    if (
                        (status === "success" ||
                        status === "partialfailed" ||
                        status === "failed" ||
                        status === "not run") &&
                        (!Array.isArray(batch.orders) || batch.orders.length === 0) &&
                        !loadingParamsRef.current[batch.id]
                    ) {
                        loadingParamsRef.current[batch.id] = true;

                        LoadParameters(instance, batch).then(() => {
                            loadedAnyParamsRef.current = true;

                            if (!paramsRenderTimerRef.current) {
                                paramsRenderTimerRef.current = setTimeout(() => {
                                    loadedAnyParamsRef.current = false;
                                    paramsRenderTimerRef.current = null;
                                    setReRender(prev => !prev);
                                }, 500);
                            }
                        });
                    }
                });
                newAllBatches.forEach(element => {
                    let hasBeenShared = false;
                    let newShareObj = null;
                    if (element["batch"]["sharedTo"])
                    {
                        if (element["batch"]["sharedTo"].length > 0)
                        {
                            newShareObj = element;
                            hasBeenShared = true;
                        }
                    }
                    newAllBatchData.push(element["batch"]);
                    if (!props.materialSearch)
                    {
                    newBatches.push(
                        <BatchRow batchesErrorModes={props.batchesErrorModes} handleSetErrorModeDialog={handleSetErrorModeDialog} sharedToMe={false} handleBatchExecuteOpenClick={handleBatchExecuteOpenClick} setSelectedBatch={setSelectedBatch} handleCancelClick={handleCancelClick} reRender={reRender} setReRender={setReRender} setClickedOrder={setClickedOrder} shareObj={newShareObj} handleBatchShareOpenClick={handleBatchShareOpenClick} hasBeenShared={hasBeenShared} handleSetAnchorElBatch={handleSetAnchorElBatch} setAnchorElDownload={setAnchorElDownload} key={element["key"]} currentSelection={element["currentSelection"]} classes={element["classes"]} globalClasses={element["globalClasses"]} lastRun={element["lastRun"]} index={element["index"]} batch={element["batch"]} material={element["material"]} statusIcon={element["statusIcon"]} orderSecondaryText={element["orderSecondaryText"]} handleBatchClick={element["handleBatchClick"]} handleEditClick={element["handleEditClick"]} checkPDMLoginAndRun={checkPDMLoginAndRun} downloadAvailability={downloadAvailability} pdmOrderXmlMissing={pdmOrderXmlMissing} batchDownloadAvailable={batchDownloadAvailable}></BatchRow>
                    );
                    }
                    else
                    {
                        let matAndRev = (element["batch"]["material"] + "/" + element["batch"]["materialRevision"]);
                        if (element["batch"]["material"].toString().toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1 
                        || element["batch"]["materialRevision"].toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1 
                        || matAndRev.toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1
                        || (element["batch"]["material"] + "/").toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1
                        || element["batch"]["name"].toString().toLowerCase().indexOf(props.materialSearch.toLowerCase()) !== -1)
                        {
                            newBatches.push(
                            <BatchRow batchesErrorModes={props.batchesErrorModes} handleSetErrorModeDialog={handleSetErrorModeDialog} sharedToMe={false} handleBatchExecuteOpenClick={handleBatchExecuteOpenClick} setSelectedBatch={setSelectedBatch} handleCancelClick={handleCancelClick} reRender={reRender} setReRender={setReRender} setClickedOrder={setClickedOrder} shareObj={newShareObj} handleBatchShareOpenClick={handleBatchShareOpenClick} hasBeenShared={hasBeenShared} handleSetAnchorElBatch={handleSetAnchorElBatch} setAnchorElDownload={setAnchorElDownload} key={element["key"]} currentSelection={element["currentSelection"]} classes={element["classes"]} globalClasses={element["globalClasses"]} lastRun={element["lastRun"]} index={element["index"]} batch={element["batch"]} material={element["material"]} statusIcon={element["statusIcon"]} orderSecondaryText={element["orderSecondaryText"]} handleBatchClick={element["handleBatchClick"]} handleEditClick={element["handleEditClick"]} checkPDMLoginAndRun={checkPDMLoginAndRun} downloadAvailability={downloadAvailability} pdmOrderXmlMissing={pdmOrderXmlMissing} batchDownloadAvailable={batchDownloadAvailable}></BatchRow>
                            );
                        }
                    }
                });
            }
            
            setFilteredBatches(tmpFilteredBatches);
            currentBatches = newBatches;
            if (newBatches.length == 0)
            {
                setShowEmpty(true);
            } 
            else 
            {
                setShowEmpty(false);
            }
            if (maxBatches > 0) {
                setNewBatchData(newAllBatchData.slice(0, maxBatches));
                setBatches(newBatches.slice(0, maxBatches));
            }
            else {
                setNewBatchData(newAllBatchData);
                setBatches(newBatches);
            }  
              
        }
        props.setReRender(!props.reRender);
    }

    let emptyRows = 0;

    let name = props.excelPath;
    let excelData;
    let dataFetched = false;
    let batchesFetched = false;
    let result = [];

    const delay = ms => new Promise(res => setTimeout(res, ms));

    async function refreshAndUpdateBatches() {
        try {
          // Combine both kinds of batches (unique IDs)
          let processingBatches = batchData.filter(b => b.status === "Processing");
          let errorModeProcessingBatches = batchData.filter(
            b => b.errorModeStatus && b.errorModeStatus.toLowerCase() === "processing"
          );
      
          let combinedBatches = [
            ...processingBatches,
            ...errorModeProcessingBatches.filter(
              eb => !processingBatches.some(pb => pb.id === eb.id)
            )
          ];
      
          let tmpBatchData = [...batchData];
      
          // Single merged refresh/fetch call
          const batchIds = combinedBatches.map(b => b.id);
          let refreshedData = [];
          if (batchIds && batchIds.length > 0) {
            refreshedData = await RefreshBatchStatus(instance, batchIds, accounts[0].username)
            .catch(err => {
                console.error("Error refreshing some batches:", err);
                return [];
            });
            if (refreshedData && refreshedData.length > 0) {
                const updatedFetchBatches = await getBatches(instance);        
                if (updatedFetchBatches?.exception) {
                    openWarningSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{updatedFetchBatches.exception}</p></div>,300000);
                } else {

                    const copenrows = document.querySelectorAll("tr.MuiTableRow-root");
                    let matchedOBatch = [];

                    copenrows?.forEach(r => {
                        const n = r.nextElementSibling;

                        if (n?.classList?.contains("collapse") && n?.classList?.contains("show")) {
                            const t = r.querySelector("p.MuiTypography-body1")?.textContent?.trim();
                            if (!t) return;

                            const id = t.split(",")[0]?.trim();
                            if (!id) return;

                            const m = updatedFetchBatches?.find(b => b?.name?.trim() === id);
                            if (m) matchedOBatch.push(m);
                        }
                    });

                    if (matchedOBatch.length) {
                        for (const b of matchedOBatch) {
                            await LoadParameters(instance, b);
                        }
                    }

                    refreshedData = updatedFetchBatches;
                }
            }
          }
      
          const validData = Array.isArray(refreshedData) ? refreshedData.filter(Boolean) : [];
          let callFetchErrorModes = false;
      
          // Update tmpBatchData with refreshed info
          if (validData && validData.length > 0) {
            validData.forEach(element => {
                const index = tmpBatchData.findIndex(obj => obj.id === element.id);
                if (index !== -1) {
                const prev = tmpBatchData[index];
                if (
                    prev.errorModeStatus &&
                    element.errorModeStatus &&
                    prev.errorModeStatus.toLowerCase() === "processing" &&
                    element.errorModeStatus.toLowerCase() !== "processing"
                ) {
                    callFetchErrorModes = true;
                }
                tmpBatchData[index] = {
                    ...prev,
                    ...element,

                    // Preserve S3-loaded parameters if refreshed DDB data does not have them.
                    orders:
                        Array.isArray(element.orders) && element.orders.length > 0
                            ? element.orders
                            : prev.orders,

                    defaultCharacteristics:
                        Array.isArray(element.defaultCharacteristics) && element.defaultCharacteristics.length > 0
                            ? element.defaultCharacteristics
                            : prev.defaultCharacteristics,

                    s3DataLoaded:
                        element.s3DataLoaded === true || prev.s3DataLoaded === true
                };
                }
            });
          }
      
          // Trigger secondary effects
          if (callFetchErrorModes) {
            props.CallSetErrorModes();
            await delay(2000);
          }
      
          const date = new Date();
          props.setBatchesUpdatedTime(date);
          setBatchData([...tmpBatchData]);
          props.setBatches([...tmpBatchData]);
          mapBatches();
          setReRender(prev => !prev);
      
        } catch (err) {
          openErrorSnackbar(
            <div style={{ whiteSpace: "nowrap" }}>
              <ErrorIcon
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  marginRight: "14px"
                }}
                className={globalClasses.whiteIcon}
              />
              <p
                style={{
                  display: "inline-block",
                  verticalAlign: "middle",
                  whiteSpace: "pre-wrap"
                }}
              >
                {"Error: " + err}
              </p>
            </div>,
            300000
          );
        }
    }

    const updateIntervalBatches = async () => {
        let processingBatches = batchData.filter((b) => b["status"] == "Processing");
        let errorModeProcessingBatches = batchData.filter((b) => b["errorModeStatus"] != null && b["errorModeStatus"].toLowerCase() == "processing");
        let tmpBatchData = batchData; 
        console.log("batchData: ", batchData);
        let refreshedBatches = processingBatches.map((b) => {
            return RefreshStatus(instance, b["id"], accounts[0].username);  
        });
        refreshedBatches = refreshedBatches.filter(function( element ) {
            return element !== undefined;
        });
        await Promise.all(refreshedBatches).then(data => {
			console.log("DATA: ", data);
            data.forEach(element => {
                var batch = tmpBatchData.findIndex((obj) => {
                    return obj["id"] == element["id"];
                }); 
                if (tmpBatchData[batch] != element)
                {                      
					console.log("tmpBatchData[batch]: ", tmpBatchData[batch]);
                    let originalOrders = tmpBatchData[batch]["orders"]; 
                    tmpBatchData[batch] = element;
                }            
            });
        }).catch((err) => {
            openErrorSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Error: " + err}</p></div>,300000);
        });
        
        errorModeProcessingBatches.forEach(element => {
            const foundVal = processingBatches.find((val) => val.id == element.id);
            if (foundVal == undefined)
            {
                processingBatches.push(element);
            }
        });
        const batchUpdates = processingBatches.map((b) => {
            return getBatch(instance, b["id"]);
        });
        await Promise.all(batchUpdates).then(async data => {
            let callFetchErrorModes = false;
			console.log("DATA2: ", data);
            data.forEach(element => {
                var batch = tmpBatchData.findIndex((obj) => {
                    return obj["id"] == element["id"];
                });
                if (tmpBatchData[batch] != element)
                {                
					console.log("tmpBatchData[batch]2: ", tmpBatchData[batch]);
                    if (tmpBatchData[batch]["errorModeStatus"] != null && element["errorModeStatus"] != null)
                    {
                        if (tmpBatchData[batch]["errorModeStatus"].toLowerCase() == "processing" && element["errorModeStatus"].toLowerCase() != "processing")
                        {
                            callFetchErrorModes = true;
                        }
                    }
                    const prev = tmpBatchData[batch];

                    tmpBatchData[batch] = {
                        ...prev,
                        ...element,

                        orders:
                            Array.isArray(element.orders) && element.orders.length > 0
                                ? element.orders
                                : prev.orders,

                        defaultCharacteristics:
                            Array.isArray(element.defaultCharacteristics) && element.defaultCharacteristics.length > 0
                                ? element.defaultCharacteristics
                                : prev.defaultCharacteristics,

                        s3DataLoaded:
                            element.s3DataLoaded === true || prev.s3DataLoaded === true
                    };
                }
            });
        if (callFetchErrorModes == true)
        {
            props.CallSetErrorModes();
            await delay(2000);
        }
        var date = new Date();
        props.setBatchesUpdatedTime(date);
        console.log("tmpBatchData: ", tmpBatchData);
        setBatchData([...tmpBatchData]);
        props.setBatches([...tmpBatchData]);
        mapBatches();
        setReRender(!reRender);
        }).catch((err) => {
            openErrorSnackbar(<div style={{whiteSpace: "nowrap"}}><ErrorIcon style={{display: "inline-block", verticalAlign: "middle", marginRight: "14px"}} className={globalClasses.whiteIcon} /><p style={{display: "inline-block", verticalAlign: "middle", whiteSpace: "pre-wrap"}}>{"Error: " + err}</p></div>,300000);
        });
    }

    useEffect(() => {
        return () => {
            if (paramsRenderTimerRef.current) {
                clearTimeout(paramsRenderTimerRef.current);
                paramsRenderTimerRef.current = null;
            }
        };
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            if (batches.length > 0)
            {
                refreshAndUpdateBatches();
            }
          }, 1 * 60 * 1000);
        
          return () => {
            clearInterval(interval);
        };
    },[batches]);

    useEffect(() => {
        if (location["pathname"] == "/") {
            setMaxBatches(5);
            setShowFooter(false);
        }
        else if (location["pathname"] == "/batches") {
            setMaxBatches(-1);
            setRowsPerPage(-1);
            setShowFooter(false);
            setEmptyTable(false);
        }
        setReRender(!reRender);
    }, [location]);


    useEffect(() => {
        mapBatches();
    }, [currentSelection, reRender, batchData])

    useEffect(() => {
        if (props.batches == null) {return;}
        setBatchData(props.batches);
        mapBatches();
    
    }, [props.batches])

    useEffect(() => {
        if (props.batches == null) {return;}
        setBatchData(props.batches);
        mapBatches();
    },[allSharedData, location, props.homePage, props.statusFilter, props.materialSearch, props.batchesErrorModes, props.downloadAvailability]);

    useEffect(() => {
        setBatchesLoaded(25);
        setEndReached(false);
        setBatches(batches.slice(0, 26));
        mapBatches();
    }, [props.resetBatchesLoaded])

    return (
        // Filters
        emptyTable
        ?
        <></>
        :
        <>
        { batchesLen < 0 ? (
            <TableContainer component={Paper}>
                <CircularProgress />
            </TableContainer>
            ) : batches.length === 0 ? (
            <TableContainer component={Paper}>
                <Typography>No batches match the search criteria</Typography>
            </TableContainer>
            ) 
            :
            <TableContainer component={Paper} className={clsx(!props.homePage && classes.tableContainer, props.homePage && classes.overflowHidden)}>
            <InfiniteScroll
            pageStart={0}
            loadMore={props.homePage == true ? ()=>{} : loading}
            hasMore={props.homePage == true ? false : (endReached && !batchesLoading) ? false : (true || false)}
            loader={props.materialSearch != "" ? <></> : <CircularProgress key={0} />}
            useWindow={false}
            >
            <Table className={classes.tableres} sx={{ width: "100%", tableLayout: "fixed" }}>
                <TableHead style={{ position: "sticky", top: "0px", background: "aliceblue", zIndex: "1000" }}>
                    <TableRow key={-1} className={classes.batchTitleRow}>
                        <TableCell key={"Execute"} className={classes.batchTitleCell} style={{width: "3%"}}>
                            {""}
                        </TableCell>
                        <TableCell key={"Batch"} style={{paddingLeft:"5px", width:"25%"}} className={classes.batchTitleCell} >
                            {"Batch Id, Description"}
                        </TableCell>
                        <TableCell key={"Status"} align="center" style={{width: "5%"}} className={classes.batchTitleCell} >
                            {"Status"}
                        </TableCell>
                        <TableCell key={"Material"} style={{width: "15%"}} align="center" className={classes.batchTitleCell}>
                            {"KM-Number"}
                        </TableCell>
                        <TableCell className={classes.batchTitleCell} style={{width: "5%"}}>
                            {"Result files"}
                        </TableCell>
                        <TableCell key={"ErrorMode"} className={classes.batchTitleCell} style={{width: "5%"}} >
                            {"Error mode"}
                        </TableCell>
                        <TableCell key={"SkipMode"} className={classes.batchTitleCell} style={{width: "5%"}} >
                            {"Skip mode"}
                        </TableCell>
                        <TableCell key={"SuccessRate"} className={classes.batchTitleCell} style={{width: "10%"}} align="center">
                            {"Success rate"}
                        </TableCell>
                        <TableCell key={"LastRun"} align="center" className={classes.batchTitleCell} style={{width: "5%"}} >
                            {"Last run"}
                        </TableCell>
                        <TableCell key={"OrderQty"} align="center" className={classes.batchTitleCell} style={{width: "5%"}} >
                            {"Batch Size"}
                        </TableCell>
                        <TableCell align="center" className={classes.batchTitleCell} style={{width: "5%"}} >
                            {"Shared"}
                        </TableCell>
                        <TableCell key={"Edit"} className={classes.batchTitleCell} style={{width: "auto"}}  >
                            {"Actions"}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {batches}
                </TableBody>
                {
                    showFooter ?
                        <TableFooter>
                            <TableRow>
                                                                                                                             <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                    colSpan={3}
                                    count={batchesLen}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        inputProps: { 'aria-label': 'rows per page' },
                                        native: true,
                                    }}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    ActionsComponent={TablePaginationActions}

                                />
                            </TableRow>
                        </TableFooter>
                        :
                        null
                }
            </Table>
            </InfiniteScroll>

            <Menu
                id="simple-menu"
                anchorEl={anchorElBatch}
                getContentAnchorEl={null}
                keepMounted={false}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={Boolean(anchorElBatch)}
                onClose={handleBatchClose}
            >
                <MenuItem disabled={editLocked} onClick={handleBatchEditClick}>Edit</MenuItem>
                <MenuItem disabled={props.showShared == true ? true : false} onClick={(e) => {handleBatchShareOpenClick(e, null)}}>Share</MenuItem>
                <MenuItem onClick={handleBatchCopyClick}>Copy</MenuItem>
                <MenuItem disabled={currentBatch == null ? true : currentBatch["createdBy"] != accounts[0].username ? true : currentBatch["status"] == "Processing"} onClick={handleBatchDeleteClick}>Delete</MenuItem>
            </Menu>

            <Menu
                id="simple-menu"
                anchorEl={anchorElDownload}
                getContentAnchorEl={null}
                keepMounted={false}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={isSelectedOrderDownloadAllowed() && Boolean(anchorElDownload)}
                onClose={handleDownloadClose}
            >    
                
                {clickedOrder && ["JOB COMPLETED", "Failed", "Cancelled", "Processing", "PDM import error"].includes(clickedOrder["status"]) && clickedOrder["configurationId"] !== "" && selectedBatch["executeArguments"]["confPDM"] == "true" &&(
                    <MenuItem
                        disabled={downloadAvailability[`${clickedOrder["configurationId"]}_PDMORDERXML`] === undefined}
                        onClick={handleCADBOMXML}
                        style={{
                            color: downloadAvailability[`${clickedOrder["configurationId"]}_PDMORDERXML`] === false ? "#b00020" : "inherit",
                            fontWeight: downloadAvailability[`${clickedOrder["configurationId"]}_PDMORDERXML`] === false ? "bold" : "normal",
                            backgroundColor: downloadAvailability[`${clickedOrder["configurationId"]}_PDMORDERXML`] === false ? "#fff3f3" : "inherit"
                        }}
                    >
                        {downloadAvailability[`${clickedOrder["configurationId"]}_PDMORDERXML`] === false
                            ? "Prepare & Download PDM CAD BOM XML"
                            : "PDM CAD BOM XML"}
                    </MenuItem>
                )}
                
                {clickedOrder && (["JOB COMPLETED","Failed", "Cancelled", "Processing", "PDM import error"].includes(clickedOrder["status"]) && clickedOrder["configurationId"] !== "") && selectedBatch["executeArguments"]["sendToCAD"] == "true" && (<MenuItem disabled={!downloadAvailability[`${clickedOrder["configurationId"]}_XML`]} onClick={handleOrderXML}>Order XML</MenuItem>)}

                {clickedOrder != null && clickedOrder["caD_duration"] != null && clickedOrder["caD_duration"] != "not available" && clickedOrder["configurationId"] != "" && (<MenuItem disabled={!downloadAvailability[`${clickedOrder["configurationId"]}_LOG`]} onClick={handleCADLog}>CAD Log</MenuItem>)}

                {clickedOrder != null && clickedOrder["status"] == "JOB COMPLETED" && clickedOrder["caD_duration"] != "not available" && clickedOrder["configurationId"] != "" && (<MenuItem disabled={!downloadAvailability[`${clickedOrder["configurationId"]}_PDM`]} onClick={handleCADResult}>CAD Result</MenuItem>)}

                {clickedOrder != null && clickedOrder["status"] == "JOB COMPLETED" && clickedOrder["mC_color"] != null && clickedOrder["configurationId"] != "" && selectedBatch["executeArguments"]["levelOfScan"] == "deep_check" && selectedBatch["executeArguments"]["sendToCAD"] == "true" && (<MenuItem disabled={!downloadAvailability[`${clickedOrder["configurationId"]}_MCLOG`]} onClick={handleCADCheck}>CAD Check</MenuItem>)}

                {clickedOrder != null && clickedOrder["status"] == "JOB COMPLETED" && selectedBatch != null && selectedBatch["executeArguments"]["levelOfScan"] == "deep_check" && clickedOrder["configurationId"] != "" && (<MenuItem disabled={!downloadAvailability[`${clickedOrder["configurationId"]}_TRACE`]} onClick={handleTrace}>Trace</MenuItem>)}

                {clickedOrder != null && clickedOrder["status"] == "JOB COMPLETED" && clickedOrder["caD_duration"] != "not available" && clickedOrder["configurationId"] != "" && selectedBatch["executeArguments"]["downloadMFG"] && (<MenuItem disabled={!downloadAvailability[`${clickedOrder["configurationId"]}_MFG`]} onClick={handleOrderMFGDownload}>MFG Package</MenuItem>)}

                {clickedOrder != null && clickedOrder["status"] == "JOB COMPLETED" && clickedOrder["configurationId"] != "" && selectedBatch["executeArguments"]["levelOfScan"] == "deep_check" && selectedBatch["executeArguments"]["sendToCAD"] == "true" && selectedBatch["executeArguments"]["confPDM"] == "true" && selectedBatch["executeArguments"]["relationships"] != "\"cws_configure_no_relationships\"" && (<MenuItem
                    onClick={handlePDMCADComp}
                    disabled={pdmCompareLoading}
                    style={{
                        color: pdmCompareAvailable ? undefined : "#2196f3", // blue if not available
                        fontWeight: pdmCompareAvailable ? "normal" : "bold"
                    }}
                >
                    <Tooltip title={pdmCompareTooltip}>
                        <span>
                            {!pdmCompareAvailable && <InfoIcon style={{verticalAlign: "middle", marginRight: 6}} />}
                            PDM CAD Comparison
                        </span>
                    </Tooltip>
                </MenuItem>)}
            </Menu>

            <ExecuteDialog 
                open={openExecuteDialog}
                setOpen={setOpenExecuteDialog}
                toggleAll={toggleAll}
                setToggleAll={setToggleAll}
                orderTitles={orderTitles}
                setOrderTitles={setOrderTitles}
                copyBatch={props.copyBatch}
                caseSelect={caseSelect}
                setCaseSelect={setCaseSelect}
                selectedBatchOrders={selectedBatchOrders}
                selectedBatch={GetEmpty(selectedBatch) ? "" : selectedBatch}
                setSelectedBatch={setSelectedBatch}
                selectedKoneMaterial={GetEmptyValue(selectedBatch, "material") ? "" : selectedBatch["material"]}
                selectedKoneMaterialRev={GetEmptyValue(selectedBatch, "materialRevision") ? "" : selectedBatch["materialRevision"]}
                selectedBatchID={GetEmptyValue(selectedBatch, "name") ? "" : selectedBatch["name"]}
                batchDescription={GetEmptyValue(selectedBatch, "description") ? "" : selectedBatch["description"]}
                newBatch={props.newBatch}
                batches={props.batches}
                setBatches={props.setBatches}
                setNewBatch={props.setNewBatch}
                setExecuteSettings={setExecuteSettings}
                mode={"batchtable"}
                reRender={reRender}
                setReRender={setReRender}
                setSkipModeValues={setSkipModeValues}
            />

            <Dialog open={shareDialogOpen} onClose={handleShareDialogClose} fullWidth={true} maxWidth="sm" classes={{paper: classes.dialogPaper}}>
                <DialogContent style={{ padding: "12px 0px" }}>
                    <div style={{display: "flex", flex: 1, padding: "0px 18px"}}>
                        <Typography variant="h5" color="textPrimary" align="left">
                            {'Share batch'}
                        </Typography>
                    <Tooltip title={!isValidUser ? 'Please fix the invalid email ids.' : "Share batch"} TransitionComponent={({ children }) => children}>
                    <span style={{marginLeft: "auto"}}>
                    <IconButton onMouseLeave={(e) => {e.preventDefault();handleInputSelected;}} onMouseOver={(e) => {e.preventDefault();handleInputSelected;}} onFocus={handleInputSelected} style={{marginLeft: "auto"}} disabled={!shareChanged || !isValidUser} className={clsx(globalClasses.blueButton, shareChanged && globalClasses.blueButtonGlow, !shareChanged && globalClasses.disabledButton)} onClick={() => {
                            handleBatchShareClick();
                        }}>
                        <GroupAdd />
                    </IconButton>
                    </span>
                </Tooltip>
                    </div>
                    <Typography variant="body2" color="textPrimary" align="left" style={{padding: "0px 18px"}}>
                            {currentBatch == null ? " " : currentBatch["description"] != null ? currentBatch["name"] + ", " + currentBatch["description"] : currentBatch["name"] + ", "}
                        </Typography>
                    <div style={{padding: "0px 18px"}}>

                        <Autocomplete
                            freeSolo
                            multiple
                            autoSelect
                            options={allUserMails}
                            size="small"
                            inputValue={shareInputValue}
                            onInputChange={(event, newInputValue) => {
                                setShareInputValue(newInputValue)
                            }}
                            getOptionLabel={(option) => option}
                            style={{ width: "250px" }}
                            onChange={(e, obj) => {
                                e.preventDefault();
                                handleSetSelectedShareUsers(e, obj);
                            }}
                            renderOption={(option, { selected }) => (
                                <React.Fragment>
                                    <ListItemText primary={option} />
                                </React.Fragment>

                            )
                            }
                            clearOnBlur={false}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"  onBlur={handleInputSelected}
                                    helperText={!isValidUser ? 'Please fix the invalid email ids.': ''} error={!isValidUser} placeholder={"To: Email"}
                                    slotProps={{
                                    input: {
                                        ...params.InputProps,
                                        type: 'search',
                                    },
                                    }}
                                />
                            )}
                        />
                    </div>
                    {/* If shared, show list */}
                    {shareObj == null ? null :
                    shareObj["batch"] == undefined ? null : 
                    <>
                    <Divider style={{marginTop: "16px", marginBottom: "8px", width: "100%"}} />
                    <Typography variant="h6" style={{padding: "0px 18px"}}>
                        Shared with
                    </Typography>
                    <div style={{padding: "0px 18px"}} className={classes.root}>
                        <List>
                            {
                                shareObj["batch"]["sharedTo"].map((e) => {
                                    return(
                                    <ListItem key={e} classes={{ root: classes.item }}>
                                        <ListItemText
                                            primary={e}
                                            />
                                            <Tooltip title={"Remove sharing"}>
                                            <IconButton style={{marginRight: "8px"}} className={classes.customButton} onClick={(event)=>{
                                                handleBatchRemoveShareClick(e, Object.keys(shareObj)[0]);
                                            }}>
                                                <CancelOutlined />
                                            </IconButton>
                                            </Tooltip>
                                    </ListItem>
                                    )
                                })
                            }
                            
                        </List>
                    </div>
                    </>
                    }
                  

                </DialogContent>
            </Dialog>

            <Dialog open={errorModeDialogOpen} fullWidth={true} maxWidth="sm">
                <DialogContent style={{ padding: "12px 0px" }}>
                    <div style={{display: "flex", flex: 1, padding: "0px 18px"}}>
                        <Typography variant="h5" color="textPrimary" align="left">
                            {'Error mode'}
                        </Typography>
                    <Tooltip title={"Close"} TransitionComponent={({ children }) => children}>
                    <span style={{marginLeft: "auto"}}>
                    <IconButton style={{marginLeft: "auto"}} className={clsx(globalClasses.blueButton)} onClick={() => {
                        handleCloseErrorMode();
                    }}>
                        <Cancel />
                    </IconButton>
                    </span>
                </Tooltip>
                    </div>
                    <List style={{padding: "0", margin: "8px"}}>
                        {
                           errorModeComponents
                        }
                    </List>
                  

                </DialogContent>
            </Dialog>
            <Dialog open = {circularProgressXMLOpen} id="CirProgXML">
            <DialogTitle>Downloading file</DialogTitle>
            <table width="200">
                <tr>
                    <td width="200" align="center">
                        <CircularProgress />
                    </td>
                </tr>
            </table>
            <DialogTitle></DialogTitle>
            </Dialog>
            <ModalPopup
                open={modalOpen}
                onClose={() => setModalOpen(false)} // Or handle via onResolve
                title="PDM Sign in"
                instance={instance}
                accounts={accounts}
                setPdmUsername={setPdmUsername}
                onResolve={handleModalResolve}
            />
        </TableContainer>
        } 
        </>
    );
}